import { Component } from '@angular/core';
import { RoutingUrls } from '@cpak/enums';

@Component({
  selector: 'cpak-p404',
  templateUrl: './p404.component.html',
  styleUrls: ['./p404.component.scss'],
})
export class P404Component {
  public readonly imageUrl = '/assets/images/404.png';
  public readonly dashboardLink = RoutingUrls.Dashboard;
}
